import { keys } from '@core/Services/Analytics/keys'
import { trackEvent } from '@core/Services/Analytics/track'

export const trackTrendingBetSelected = (data: object): void =>
  trackEvent(keys.trendingBetSelected, { data })

export const trackTrendingBetSortingChanged = (data: object): void =>
  trackEvent(keys.trendingBetSortingChanged, { data })
